import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["url", "type", "protocol", "results", "button"]
  static values = { detectUrl: String }

  async detect() {
    const url = this.urlTarget.value.trim()
    if (!url) return this.render("warning", "Informe a URL da integração antes de analisar.")

    this.buttonTarget.disabled = true
    this.render("loading", "Analisando a estrutura do feed...")

    try {
      const resp = await fetch(this.detectUrlValue, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content
        },
        body: JSON.stringify({ url })
      })
      this.apply(await resp.json())
    } catch {
      this.render("error", "Erro ao analisar a URL. Tente novamente.")
    } finally {
      this.buttonTarget.disabled = false
    }
  }

  apply(result) {
    if (result.normalized_url) this.urlTarget.value = result.normalized_url
    if (result.protocol) this.protocolTarget.value = result.protocol
    if (result.name) this.typeTarget.value = result.name

    const label = this.typeTarget.selectedOptions[0]?.text

    switch (result.status) {
      case "detected":
        this.render("success", `Integrador detectado: <strong>${label}</strong>. Tipo, protocolo e URL preenchidos automaticamente.`)
        break
      case "ambiguous":
        this.render("warning", `${result.details} Sugerido: <strong>${label}</strong> - confirme antes de salvar.`)
        break
      default:
        this.render("error", result.details || "Não foi possível analisar a URL.")
    }
  }

  render(kind, html) {
    const styles = {
      loading: "bg-blue-50 border-blue-200 text-blue-800",
      success: "bg-green-50 border-green-200 text-green-800",
      warning: "bg-yellow-50 border-yellow-200 text-yellow-800",
      error: "bg-red-50 border-red-200 text-red-800"
    }
    this.resultsTarget.innerHTML = `<div class="border rounded-lg p-3 text-sm ${styles[kind]}">${html}</div>`
  }
}
